import { ToneDto, ToneDtoImpl } from '../tonedto';
import { GroupDto } from './groupdto';

export interface ListTonesDto extends ToneDto
{
    getLanguage():string;
    getMsisdn():string;
    getStartIndex():string;
    getEndIndex():string;
    getRbtMode():string;
    getIsShuffle(): string;
    getTimeType(): string;
    getType():string;
    getCallerStatus():string;
    getCaller():string;
    getTime():string;
    getIsStatusRBT(): boolean;
    getFrom():string;
    getTo():string;
    getRepeats():string[];
    getGroupDto(): GroupDto;
    getServiceName():string;
}

export class ListTonesDtoImpl extends ToneDtoImpl implements ListTonesDto
{
    private isStatusRBT: boolean = false;
    private language: string;
    private msisdn: string;
    private startIndex: string;
    private endIndex: string;
    private rbtMode: string;
    private isShuffleOn:string;
    private  serviceName:string;
    private timeType: string;
    private type: string;
    private callerStatus: string;
    private caller: string;
    private time: string;
    private from: string;
    private to: string;
    private repeats: string[];
    private groupDto: GroupDto;

    getTimeType(): string
    {
        return this.timeType;
    }

    setTimeType(timeType: string)
    {
        this.timeType = timeType;
    }
    getIsStatusRBT(): boolean {
        return this.isStatusRBT;
     }
     setIsStatusRBT(isStatusRBT: boolean)
     {
         this.isStatusRBT = isStatusRBT;
     }

     getServiceName():string{
         return this.serviceName;
     }
     setServiceName(serviceName:string):void
     {
         this.serviceName = serviceName;
     }
     setIsShuffle(isShuufleOn:string)
     {
         this.isShuffleOn = isShuufleOn;
     }
    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }

    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }
    getMsisdn(): string 
    {
        return this.msisdn;
    }

    getIsShuffle(): string{
        return this.isShuffleOn;
    }
     
    setStartIndex(startIndex: string)
    {
        this.startIndex = startIndex;
    }
    getStartIndex(): string 
    {
        return this.startIndex;
    }

    setEndIndex(endIndex: string)
    {
        this.endIndex = endIndex;
    }
    getEndIndex(): string 
    {
        return this.endIndex;
    }

    setType(type: string)
    {
        this.type = type;
    }
    getType(): string 
    {
        return this.type;
    }

    setRbtMode(rbtMode: string)
    {
        this.rbtMode = rbtMode;
    }
    getRbtMode(): string 
    {
        return this.rbtMode;
    }

    getCallerStatus(): string 
    {
        return this.callerStatus;
    }
    setCallerStatus(callerStatus: string)
    {
        this.callerStatus = callerStatus;
    }

    getCaller(): string 
    {
        return this.caller;
    }
    setCaller(caller: string)
    {
        this.caller = caller;
    }

    getTime(): string 
    {
        return this.time;
    }
    setTime(time: string)
    {
        this.time = time;
    }

    getFrom(): string 
    {
        return this.from;
    }
    setFrom(from: string) 
    {
        this.from = from;
    }

    getTo(): string 
    {
        return this.to;
    }
    setTo(to: string) 
    {
        this.to = to;
    }

    getRepeats(): string[] 
    {
        return this.repeats;
    }
    setRepeats(repeats: string[]) 
    {
        this.repeats = repeats;
    }
    
    setGroupDto(groupDto: GroupDto)
    {
        this.groupDto = groupDto;
    }
    getGroupDto(): GroupDto
    {
        return this.groupDto;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/listtones/listtonesdto.tsx